import { Component, Story, Knobs } from './DocTypes';
import { TagMobileSideMenuListOptionDocs } from './TagMobileSideMenuListOptionDocs';

const BasicStoryKnobs: Knobs = {
  heading: { default: 'Simple Popover', editor: 'textbox' },
  showBackButton: { default: false, editor: 'checkbox' },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A list for the side menu for mobile apps',

  coreComponent_v3: {
    html: `<tag3-mobile-side-menu-list value="1" accent="keppel">
  <tag3-mobile-side-menu-list-option value='0' heading="Access UK Ltd" label="Richard Oliver"
    image-src='https://images.pexels.com/photos/220451/pexels-photo-220451.jpeg?auto=compress&cs=tinysrgb&h=350'>
  </tag3-mobile-side-menu-list-option>
  <tag3-mobile-side-menu-list-option value='1' heading="Organisation One" label="Richard Oliver"
    image-src='https://images.pexels.com/photos/220452/pexels-photo-220452.jpeg?auto=compress&cs=tinysrgb&h=350'>
  </tag3-mobile-side-menu-list-option>
  <tag3-mobile-side-menu-list-option value='2' heading="Organisation Two" label="Richard Oliver"
    image-src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'>
  </tag3-mobile-side-menu-list-option>
  <tag3-mobile-side-menu-list-option value='3' heading="Organisation Three" placeholder="RO">
  </tag3-mobile-side-menu-list-option>  
</tag3-mobile-side-menu-list>
`,
    knobs: {
      position: {
        editor: 'dropdown',
        editorOptions: ['left', 'right', ''],
        default: 'right',
      },
      ...BasicStoryKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<TagMobileSideMenuList value="1" accent="keppel">
  <TagMobileSideMenuListOption value='0' heading="Access UK Ltd" label="Richard Oliver"
    imageSrc='https://images.pexels.com/photos/220451/pexels-photo-220451.jpeg?auto=compress&cs=tinysrgb&h=350'>
  </TagMobileSideMenuListOption>
  <TagMobileSideMenuListOption value='1' heading="Organisation One" label="Richard Oliver"
    imageSrc='https://images.pexels.com/photos/220452/pexels-photo-220452.jpeg?auto=compress&cs=tinysrgb&h=350'>
  </TagMobileSideMenuListOption>
  <TagMobileSideMenuListOption value='2' heading="Organisation Two" label="Richard Oliver"
    imageSrc='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'>
  </TagMobileSideMenuListOption>
  <TagMobileSideMenuListOption value='3' heading="Organisation Three" placeholder="RO">
  </TagMobileSideMenuListOption>  
</TagMobileSideMenuList>`,
    knobs: {
      position: {
        editor: 'dropdown',
        editorOptions: ['left', 'right', ''],
        default: 'right',
      },
      ...BasicStoryKnobs,
    },
  },
};

export const TagMobileSideMenuListDocs: Component = {
  type: 'component',
  name: 'mobile-side-menu-list',
  description: 'Renders a list for the side menu for a mobile device',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'A unique name for the side menu list',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Whether the side menu list is disabled or not',
      type: 'boolean',
    },
    {
      name: 'accent',
      description: 'The colour of the selected state',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The selected option',
      type: 'any',
    },
    {
      name: 'data',
      description: 'Any array of data that drives the side menu list items',
      type:
        'string[] | { heading: string; label?: string; imageSrc?: string; placeholder?: string; value: any; }[]',
    },
    {
      name: 'textField',
      description: 'The field in the data array prop that gives the text to show in the component',
      type: 'string',
      default: 'label',
    },
    {
      name: 'valueField',
      description:
        'The field in the data array prop that gives the actual value put in the value prop',
      type: 'string',
      default: 'value',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'sideMenuListValueChange',
      description: 'Raised when an option is selected',
      parameters: [],
    },
  ],
  methods: [],
  stories: [PlaygroundStory],
  childComponents: [TagMobileSideMenuListOptionDocs],
};
